/**
 * renter-upcoming — RenterDashboardPage Upcoming Rentals list.
 *
 * 56×56 listing photo (emoji fallback), listing title, provider +
 * date range meta, amount and either UrgencyTag (time-sensitive) or
 * StatusBadge (fallback) on the right. Urgency adds a left-border
 * orange accent on the whole row.
 */
import React from 'react';

import { useIntl } from '../../../util/reactIntl';
import ResponsiveImage from '../../ResponsiveImage/ResponsiveImage';
import StatusBadge from '../StatusBadge';
import UrgencyTag, { computeUrgency } from '../UrgencyTag';
import css from '../TransactionCard.module.css';
import { formatCardDateRange } from '../formatCardDateRange';

const RenterUpcomingLayout = ({ data }) => {
  const intl = useIntl();
  const {
    state,
    processName,
    startDate,
    endDate,
    firstImage,
    imageVariants,
    listingTitle,
    providerName,
    emoji,
    payinCents,
    serviceLabel,
  } = data;

  const urgency = computeUrgency(state, startDate, endDate);
  const amountDisplay =
    typeof payinCents === 'number' ? `$${(payinCents / 100).toFixed(2)}` : null;
  const dateRange = formatCardDateRange(intl, startDate, endDate);

  return (
    <div className={`${css.cardRow} ${css.cardFull} ${urgency ? css.cardUrgent : ''}`}>
      <div className={css.cardLeft}>
        <div className={css.thumb56}>
          {firstImage && imageVariants.length > 0 ? (
            <ResponsiveImage
              rootClassName={css.thumbImage}
              alt={listingTitle}
              image={firstImage}
              variants={imageVariants}
            />
          ) : (
            <span className={css.thumbEmoji}>{emoji}</span>
          )}
        </div>
        <div className={css.cardBody}>
          <h4 className={css.cardTitle}>{listingTitle}</h4>
          <p className={css.cardMeta}>
            {providerName}
            {dateRange ? ` · ${dateRange}` : ''}
            {serviceLabel ? ` · ${serviceLabel}` : ''}
          </p>
        </div>
      </div>
      <div className={css.cardRight}>
        {amountDisplay ? <div className={css.cardAmount}>{amountDisplay}</div> : null}
        {urgency ? (
          <UrgencyTag text={urgency.text} />
        ) : (
          <StatusBadge state={state} processName={processName} />
        )}
      </div>
    </div>
  );
};

export default RenterUpcomingLayout;
